import { observer } from 'mobx-react';
import { IStepControl, Step } from '../../../domains/wizard';
import { ContactsReview } from './contacts-review';
import React from 'react';
import { HeaderReview } from './header-review';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../store';
import i18n from 'i18next';

interface IProps {
  stepControl: IStepControl;
}

export const OnboardingReview = observer((props: IProps) => {
  const { t } = useTranslation('', { keyPrefix: 'REVIEW_AND_SIGN_UP' });
  const { onboardingInformationStore, tenantStore, quoteStore } = useStore();
  const { config } = tenantStore;
  const { targetPortDate, targetInstallDate } = onboardingInformationStore.information;
  const { isSelfOnboarding, isContactOnlyPartner } = quoteStore;
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };

  return (
    <div className="container-grey m-bottom-30">
      <HeaderReview stepControl={props.stepControl} step={Step.Onboarding} />

      {!isContactOnlyPartner && <ContactsReview contactsType={'onboarding'} />}

      <div className="avoid-break">
        {!isContactOnlyPartner && <hr />}
        <h4>{t('TARGET_DATES')}</h4>
        {config.useOnlyOneTargetDate && (
          <div className="d-flex">
            <div className="container-readonly">
              <label>{t('DESIRED_START_DATE')}</label>
              <span>{targetInstallDate.value?.toLocaleDateString(i18n.language, options)}</span>
            </div>
          </div>
        )}
        {!config.useOnlyOneTargetDate && (
          <div className="d-flex">
            <div className="container-readonly">
              <label>{t('TARGET_INSTALL_DATE')}</label>
              <span>{targetInstallDate.value?.toLocaleDateString(i18n.language, options)}</span>
            </div>
            {targetPortDate.value && (
              <div className="container-readonly left-30">
                <label>{t('TARGET_PORT_DATE')}</label>
                <span>{targetPortDate.value?.toLocaleDateString(i18n.language, options)}</span>
              </div>
            )}
          </div>
        )}
      </div>

      {isSelfOnboarding && (
        <>
          <hr />
          <ContactsReview contactsType={'admin'} />
        </>
      )}
    </div>
  );
});
